import { Component, Input } from '@angular/core';
import { Evento } from '../../models/evento.model';
import { SimpleEventComponent } from './simple-event/simple-event.component';

@Component({
  selector: 'c-event-time-view',
  templateUrl: './event-time-view.component.html',
  styleUrl: './event-time-view.component.css',
  imports: [SimpleEventComponent],
  standalone: true,
})
export class EventTimeViewComponent {
  @Input() date!: Date;

  isToday = false;
  px = 0;
  actualTime = '';
  timeReference = 'a.m.';

  @Input() events: Evento[] = [];

  ngOnInit() {
    const today = new Date();

    this.isToday =
      this.date.getDate() == today.getDate() &&
      this.date.getMonth() == today.getMonth() &&
      this.date.getFullYear() == today.getFullYear();

    if (this.isToday) {
      this.px = (today.getHours() * 60 + today.getMinutes()) / 2;
      this.timeReference = today.getHours() >= 12 ? 'p.m.' : 'a.m.';
      this.actualTime = today.getHours() + ':' + today.getMinutes();
    }
  }
}
